import { apiSlice } from "core/api";

const api = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getPresignedPost: build.mutation<
      { url: string; fields: Record<string, string> },
      { fileName: string; folder: string }
    >({
      query: (body) => ({
        method: "POST",
        url: "upload",
        body,
      }),
    }),

    getPresignedXMLConfigPost: build.mutation<
      { url: string; fields: Record<string, string> },
      { filename: string }
    >({
      query: (body) => ({
        method: "POST",
        url: "upload-xmlconfig",
        body,
      }),
    }),

    uploadToS3: build.mutation<
      void,
      { file: File; data: { url: string; fields: Record<string, string> } }
    >({
      queryFn: async ({ file, data: { url, fields } }) => {
        return new Promise((resolve) => {
          try {
            const formData = new FormData();

            // Append all presigned post fields first
            Object.entries(fields).forEach(([key, value]) => {
              formData.append(key, value);
            });

            // Manually add Content-Type field to match S3 policy condition
            // Extract content type from file - fail clearly if unknown
            const contentType = file.type;
            if (!contentType) {
              throw new Error("File type is unknown - cannot upload to S3");
            }
            formData.append("Content-Type", contentType);

            // Append file LAST (S3 requirement for presigned posts)
            formData.append("file", file);

            const xhr = new XMLHttpRequest();

            xhr.open("POST", url);

            xhr.onload = () => {
              if (xhr.status >= 200 && xhr.status < 300) {
                resolve({ data: undefined });
              } else {
                resolve({
                  error: {
                    status: xhr.status,
                    data: xhr.responseText,
                  },
                });
              }
            };

            xhr.onerror = () => {
              resolve({
                error: {
                  status: "FETCH_ERROR",
                  error: "Network error occurred",
                },
              });
            };

            xhr.send(formData);
          } catch (error) {
            resolve({
              error: {
                status: "FETCH_ERROR",
                error: String(error),
              },
            });
          }
        });
      },
    }),
  }),
});

export const {
  useGetPresignedPostMutation,
  useGetPresignedXMLConfigPostMutation,
  useUploadToS3Mutation,
} = api;
